import React from "react";
import styles from "./SortBar.module.css";
import { FiFilter } from "react-icons/fi";
import { Dropdown } from "primereact/dropdown";

interface SortBarProps {
  totalItems: number;
  currentPage: number;
  itemsPerPage: number;
  sortValue: string;
  onSortChange: (val: string) => void;
  onFilterToggle: () => void;
}

const SortBar: React.FC<SortBarProps> = ({
  totalItems,
  currentPage,
  itemsPerPage,
  sortValue,
  onSortChange,
  onFilterToggle,
}) => {
  const from = (currentPage - 1) * itemsPerPage + 1;
  const to = Math.min(currentPage * itemsPerPage, totalItems);
  const sortOptions = [
    { label: "Sort", value: "" },
    { label: "Popular", value: "POPULAR" },
    { label: "Price: Low to High", value: "ASC" },
    { label: "Price: High to Low", value: "DESC" },
  ];
  return (
    <div className={styles.bar}>
      <div className={styles.left}>
        {/* Mobile filter toggle */}
        <button
          className={styles.filterToggle}
          onClick={onFilterToggle}
          aria-label="Open filters"
        >
          <FiFilter size={16} />
          <span>Filters</span>
        </button>
        <p className={styles.count}>
          Showing{" "}
          <strong>
            {from}–{to}
          </strong>{" "}
          of <strong>{totalItems}</strong> items found
        </p>
      </div>
      <div className={styles.right}>
        <label className={styles.sortLabel}>SORT BY:</label>
        {/* <select
          value={sortValue}
          className={styles.dropdown}
          onChange={(e) => onSortChange(e.target.value)}
        >
          <option value="">Search</option>
          <option value="POPULAR">Popular</option>
          <option value="ASC">Price: Low to High</option>
          <option value="DESC">Price: High to Low</option>
        </select> */}
        <Dropdown
          value={sortValue}
          options={sortOptions}
          optionLabel="label"
          optionValue="value"
          onChange={(e) => onSortChange(e.value)}
          placeholder="Search"
          className={styles.dropdown}
        />
      </div>
    </div>
  );
};

export default SortBar;
